module.exports = __webpack_public_path__ + "images/f14c95d5.jpg";